<!--
    @负责人: libaiqi
    @创建时间: 2019-02-27
    @版本:v2.0.2
    @描述: 远程配置
-->
<template>
  <div class="remoteConfig__content">
    <div class="remoteConfig__editor">
      <div id="page"></div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import rac from '@/plugins/rac-mixin'
  import remoteConfigBiz from '@/logic/systemSetting/remoteConfigBiz.js'
  import dic from '@/components/mixins/dic'
  import G6 from '@antv/g6'
  const G6Plugins = require('@antv/g6/build/plugins')
  const dagre = new G6Plugins['layout.dagre']()
  export default {
    mixins: [rac, dic],
    data () {
      return {
        editor: null
      }
    },
    watch: {
      '$route' (nV, oV) {
        if (nV.name === 'remoteConfig' && oV.name === 'editSite') {
          this.getAllSite()
        }
      }
    },
    methods: {
      init () {
        this.getAllSite()
      },
      getAllSite () {
        remoteConfigBiz.findAll().then((data) => {
          let nodeData = {
            nodes: [],
            edges: []
          }
          let errow = {
            source: '',
            target: []
          }
          data.map((item) => {
            nodeData.nodes.push({
              siteCode: item.siteCode,
              siteName: item.siteName,
              id: item.id
            })
            if (item.master) {
              errow.source = item.id
            } else {
              errow.target.push(item.id)
            }
          })
          if (errow.source !== '') {
            errow.target.map((item) => {
              nodeData.edges.push({
                source: errow.source,
                target: item
              })
            })
          }
          this.initEditor(nodeData)
        })
      },
      initEditor (data) {
        if (this.editor !== null) {
          this.editor.destroy()
        }
        G6.registerNode('rect', {
          getPath: function getPath (item) {
            var width = 200
            var height = 80
            return G6.Util.getRectPath(-width / 2, -height / 2, width, height, 10)
          }
        })
        this.editor = new G6.Graph({
          container: 'page',
          fitView: 'lt',
          height: window.innerHeight - 230, // 画布高
          plugins: [dagre],
          fitViewPadding: 20,
          defaultIntersectBox: 'rect', // 使用矩形包围盒
          modes: {
            default: ['hehaviourName'],
            mouseBehavior: ['mouseEnterFillBlue', 'mouseLeaveResetFill']
          },
          mode: 'mouseBehavior'
        })
        this.editor.node({
          shape: 'rect',
          label: function label (model) {
            return model.siteName
          },
          style: {
            stroke: '#9dd1f5',
            fill: '#fff',
            fillOpacity: 0.45,
            lineWidth: 1
          }
        })
        this.editor.on('node:click', ev => {
          if (!ev.item.model.siteCode) return
          this.$router.push({name: 'editSite', query: { siteCode: ev.item.model.siteCode }})
        })
        this.editor.edge({
          style: {
            endArrow: false
          }
        })
        this.editor.read(data)
      }
    },
    mounted () {
      this.init()
    }
  }
</script>
<style scoped>
  .remoteConfig__content {
    min-height: 200px;
  }
</style>
